<template>
  <a :href="invoiceDownloadUrl" target="_blank">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    id: String
  },
  computed: {
    invoiceDownloadUrl() {
      return process.env.VUE_APP_SPABOOT_API_URL + `/invoices/documents?invoice=${this.id}`
    }
  }
}

</script>
